module.exports = "/_next/static/images/curry_kiyma_curry_grill-9ba922fa11f6178dca4a3db3dcd80422.jpeg";